import serviceSettingsComponent from './service_settings.component'
import serviceSettingsAll from './all'
import serviceSettingsChecklist from './service-checklist'
import serviceSettingsAtmMakes from './atm-makes'
import serviceActionPriorities from './service-action-priorities'

let serviceSettingsModule = angular.module('serviceSettings', [
    serviceSettingsAll,
    serviceSettingsChecklist,
    serviceSettingsAtmMakes,
    serviceActionPriorities
])
    .component('serviceSettings', serviceSettingsComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('service-settings.all', {
                url: '/all/:page',
                component: 'serviceSettingsAll'
            })
            .state('service-settings.checklist', {
                url: '/checklist',
                component: 'serviceSettingsChecklist',
            })
            .state('service-settings.atmMakes', {
                url: '/atm-makes',
                component: 'serviceSettingsAtmMakes',
            })
            .state('service-settings.actionPriorities', {
                url: '/service-action-priorities',
                component: 'serviceActionPriorities',
            })
    })
    .name;

export default serviceSettingsModule;


// WEBPACK FOOTER //
// ./client/app/components/service_settings/index.js